import Vue from 'vue';

Vue.prototype.$APP_NAME= location.hostname;
Vue.prototype.$APP_URL= location.origin;
Vue.prototype.$APP_DOMEN= 'mindplays.com';
Vue.prototype.$API_URL= 'https://mindplays.com/api/oauth';
